import { Link, useHistory } from "react-router-dom";
import React from "react";
import GenericButton from "../../common/genericButton";
import GenericInput from "../../common/GenericInput";
import GenericModal from "../../common/genericModal";
import styles from "./login.module.scss";

const Login = ({ isOpen, toggle, handleForgot, handleSignUp }) => {
  const history = useHistory();
  const handleLogin = () => {
    history.push("/wallet");
  };
  const changeHandler = () => {};
  return (
    <>
      <GenericModal isOpen={isOpen} toggle={toggle}>
      <div className={styles.mainheading}>Login</div>
      <div className={styles.title}>Enter your Email and  Password</div>
        <div className={styles.fieldWrapper}>
          <GenericInput
            label="Email"
            placeholder="thomas.brown@email.com"
            type="text"
            withRightIcon={false}
            name="email"
            icon={"/assets/icons-email.svg"}
            onChange={changeHandler}
          />
        </div>
        <div className={styles.fieldWrapper}>
          <GenericInput
            label="Password"
            placeholder="•••••••••••"
            type="text"
            withRightIcon={"/assets/lock.png"}
            name="oldPassowrd"
            icon={"/assets/key.svg"}
            onChange={changeHandler}
          />
        </div>

        <div className={styles.text} onClick={handleForgot}>
          Forgot Password
        </div>

        <div className={styles.fieldWrapper}>
          <GenericButton title={"Login"} onClick={handleLogin} />
        </div>

        <div className={styles.footer}>
          Don’t have an account?{" "}
          <span onClick={handleSignUp} style={{ cursor: "pointer" }}>
            Sign up now!
          </span>
        </div>
      </GenericModal>
    </>
  );
};

export default Login;
